import React, { useState } from 'react'
import NetaqInput from '../NetaqInput';
import { useTranslate } from '../TranslationText';
import { normailizeOwnerName } from '../../helper/nomalizeOwnerName';


export default function UserCentralDropDown({ onChange }) {
    const { translate } = useTranslate();
    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';

    function renderSelectedAccount() {
        const loggedinId = localStorage.getItem("EAHSUserID");
        const selectedId = localStorage.getItem("currentSubAccountId");
        let uiSelectedObg = {};
        if (loggedinId == selectedId) {
            uiSelectedObg = {
                label:
                    currentLanguage == "en"
                        ? JSON.parse(localStorage.getItem("eahsUserProfile"))?.ownerRegisterNo +
                        " - " +
                        JSON.parse(localStorage.getItem("eahsUserProfile"))?.fullName
                        : JSON.parse(localStorage.getItem("eahsUserProfile"))?.ownerRegisterNo +
                        " - " +
                        JSON.parse(localStorage.getItem("eahsUserProfile"))?.fullNameAr,
                value: localStorage.getItem("EAHSUserID"),
                text:
                    currentLanguage == "en"
                        ? JSON.parse(localStorage.getItem("eahsUserProfile"))?.ownerRegisterNo +
                        " - " +
                        JSON.parse(localStorage.getItem("eahsUserProfile"))?.fullName
                        : JSON.parse(localStorage.getItem("eahsUserProfile"))?.ownerRegisterNo +
                        " - " +
                        JSON.parse(localStorage.getItem("eahsUserProfile"))?.fullNameAr,
            }
        } else if (loggedinId != selectedId) {

            const selectedSubAccount = JSON.parse(localStorage.getItem("eahsUserProfile")).subAccounts.find((x) => x.value == selectedId);

            const registerNo = selectedSubAccount?.registerNo;
            const textEn = selectedSubAccount?.text;
            const textAr = selectedSubAccount?.textAr;

            const prefix = registerNo ? registerNo + " - " : "";

            uiSelectedObg = {
                label:
                    currentLanguage === "en"
                        ? prefix + textEn
                        : prefix + textAr,
                text:
                    currentLanguage === "en"
                        ? prefix + textEn
                        : prefix + textAr,
                value: selectedId,
            };
        }
        return uiSelectedObg;
    }


    const [profile, setProfile] = useState(renderSelectedAccount());



    const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];
    const subAccountId = localStorage.getItem("currentSubAccountId");

    const handelSelectedAccountChange = async (element) => {
        localStorage.setItem("currentSubAccountId", element?.value);
        setProfile(element)
        onChange(element?.value);
    };
    const getSelectedAccountName = () => {
        const selectAccount = userProfile?.subAccounts.filter(
            (x) => x.value == subAccountId
        );

        if (selectAccount.length > 0) {
            return selectAccount[0];
        }
        else {
            return false;
        }
    };
    const options = [{
        label:
            normailizeOwnerName(userProfile, currentLanguage, false),
        value: localStorage.getItem("EAHSUserID"),
    },
    ...subOwnerProfilesByIdData.map((a) => ({
        label:
            normailizeOwnerName(a, currentLanguage),
        value: a.value,
    }))];
    const uniqueOptions = Array.from(
        new Map(options.map(item => [item.value, item])).values()
    );





    return (
        <div>{userProfile?.isAgent != true || true ? (
            <>
                {subOwnerProfilesByIdData?.length > 0 &&
                    <NetaqInput
                        label={translate("web.selectedAccount", "Selected Account")}
                        name="selectAccount"
                        type="select"
                        listSelect={uniqueOptions}
                        value={profile}
                        onChange={(e) => {
                            handelSelectedAccountChange(e);
                        }}
                        placeholder={localStorage.getItem("EAHSUserFullName")}
                    />
                }
            </>
        ) : (
            <label className="capatalize_text">
                {getSelectedAccountName().registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage === "en" ? "" : "Ar"}`
                    ]}
            </label>
        )}</div>
    )
}
